/* eslint-disable */

import { TlbsMenuProps } from './type';
import { PropType } from 'vue';
 
export default {
  /** 菜单数据 */
  menuData: {
    type: Array as PropType<TlbsMenuProps['menuData']>,
    default: []
  },
  /** 菜单展示模式 */
  mode: {
    type: String as PropType<TlbsMenuProps['mode']>,
    default: 'vertical'
  },
  /** 激活菜单项 */
  defaultValue: {
    type: [String, Number] as PropType<TlbsMenuProps['defaultValue']>,
    default: ''
  }
};
 